/**
 * Utility belt for scaling the size of your apps UI across different sized devices.
 *
 * @see https://medium.com/soluto-engineering/size-matters-5aeeb462900a
 */

const addUnit = (size: number, unit: 'px' = 'px') => `${size}${unit}`;

/**
 * @returns a linear scaled result of the provided size, based on your device's screen width
 */
export const scaleInt = (size: number) => size;

export const scale = (size: number) => addUnit(scaleInt(size));

/**
 * @returns a linear scaled result of the provided size, based on your device's screen height.
 */
export const verticalScaleInt = (size: number) => size;

export const verticalScale = (size: number) => addUnit(verticalScaleInt(size));

/**
 * Sometimes you don't want to scale everything in a linear manner, that's where moderateScale comes in.
 * The cool thing about it is that you can control the resize factor (default is 0.5).
 * If normal scale will increase your size by +2X, moderateScale will only increase it by +X
 */
export const moderateScaleInt = (size: number, factor = 0.5) =>
  size + (scaleInt(size) - size) * factor;

export const moderateScale = (size: number, factor = 0.5) =>
  addUnit(moderateScaleInt(size, factor));

/**
 * Same as moderateScale, but using verticalScale instead of scale.
 */
export const moderateVerticalScaleInt = (size: number, factor = 0.5) =>
  size + (verticalScaleInt(size) - size) * factor;

export const moderateVerticalScale = (size: number, factor = 0.5) =>
  addUnit(moderateVerticalScaleInt(size, factor));

// shorthands
/**
 * @alias
 */
export const si = scaleInt;

/**
 * @alias
 */
export const s = scale;

/**
 * @alias
 */
export const vsi = verticalScaleInt;

/**
 * @alias
 */
export const vs = verticalScale;

/**
 * @alias
 */
export const msi = moderateScaleInt;

/**
 * @alias
 */
export const ms = moderateScale;

/**
 * @alias
 */
export const mvsi = moderateVerticalScaleInt;

/**
 * @alias
 */
export const mvs = moderateVerticalScale;
